import type { RouteLocationRaw } from "vue-router"
import { Page } from "@/graphql"
import { Route } from "@/utils/routing"

const DefaultPageRoutes: Record<Page, RouteLocationRaw> = {
	[Page.Activity]: { name: Route.Activity },
	[Page.Exploration]: { name: Route.Home },
	[Page.Hunting]: { name: Route.Hunting },
	[Page.Opportunities]: { name: Route.Home, query: { table: Page.Opportunities } },
	[Page.Transactions]: { name: Route.Home, query: { table: Page.Transactions } },
	[Page.Buyers]: { name: Route.Home, query: { table: Page.Buyers } },
}

export function getDefaultPageRoute(defaultPage: Page | null | undefined): RouteLocationRaw {
	return DefaultPageRoutes[defaultPage ?? Page.Exploration]
}
